import axios from 'axios';
import { saveAs } from 'file-saver';




function getCookie(cname) {
     var name = cname + "=";
     var ca = document.cookie.split(';');
     for(var i=0; i<ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0)===' ') c = c.substring(1);
        if(c.indexOf(name) === 0)
           return c.substring(name.length,c.length);
     }
     return "";
}


//createUser
export const runHit = (ionName, ionsNumber, cubeSize, mergeFile, closeModal) => {
  return function(dispatch) {
    let bodyFormData = new FormData();
    bodyFormData.append('pdba', mergeFile);
    bodyFormData.append('ion_name', ionName);
    bodyFormData.append('ions_number', ionsNumber);
    bodyFormData.append('cube_size', cubeSize);
    const csrfToken = getCookie('csrftoken');


    return axios({
      method: "post",
      url: "position_hit",
      data: bodyFormData,
      responseType: 'blob',
      headers: { "Content-Type": "multipart/form-data", "X-CSRFToken": csrfToken, },

      }).then(response => {

        saveAs(new Blob([response.data],{type: 'application/zip'}), "hitpdb.zip")
        closeModal();
      })
      .catch( exception => {
        console.log(exception); //TODO display error page
      });
  };
};

export const runHitV2 = (frameID, stepSize, fillingRatio, mergeFile, closeModal) => {
  return function(dispatch) {
    let bodyFormData = new FormData();
    bodyFormData.append('pdba', mergeFile);
    bodyFormData.append('frame_ID', frameID);
    bodyFormData.append('step_size', stepSize);
    bodyFormData.append('filling_ratio', fillingRatio);
    const csrfToken = getCookie('csrftoken');


    return axios({
      method: "post",
      url: "position_hit_v2",
      data: bodyFormData,
      responseType: 'blob',
      headers: { "Content-Type": "multipart/form-data", "X-CSRFToken": csrfToken, },

      }).then(response => {

        saveAs(new Blob([response.data],{type: 'application/zip'}), "hitV2pdb.zip")
        closeModal();
      })
      .catch( exception => {
        console.log(exception); //TODO display error page
      });
  };
};

// manipulation tool seperate
export const runSeperate = (minDistance, maxDistance, stepSize, pdbA, pdbB, closeModal) => {
  return function(dispatch) {
    let bodyFormData = new FormData();
    bodyFormData.append('distance_min', minDistance);
    bodyFormData.append('distance_max', maxDistance);
    bodyFormData.append('step_size', stepSize);
    bodyFormData.append('pdba', pdbA);
    bodyFormData.append('pdbb', pdbB);
    const csrfToken = getCookie('csrftoken');

    return axios({
      method: "post",
      url: "seperate",
      data: bodyFormData,
      responseType: 'blob',
      headers: { "Content-Type": "multipart/form-data", "X-CSRFToken": csrfToken, },

      }).then(response => {

        saveAs(new Blob([response.data],{type: 'application/zip'}), "seperated.zip")
        closeModal();
      })
      .catch( exception => {
        console.log(exception); //TODO display error page
      });
  };
};



// manipulation tool rotate
export const runRotate = (minAngle, maxAngle, stepSize, pdbA, pdbB, closeModal) => {
  return function(dispatch) {
    let bodyFormData = new FormData();
    bodyFormData.append('angle_min', minAngle);
    bodyFormData.append('angle_max', maxAngle);
    bodyFormData.append('step_size', stepSize);
    bodyFormData.append('pdba', pdbA);
    bodyFormData.append('pdbb', pdbB);
    const csrfToken = getCookie('csrftoken');

    return axios({
      method: "post",
      url: "rotate",
      data: bodyFormData,
      responseType: 'blob',
      headers: { "Content-Type": "multipart/form-data", "X-CSRFToken": csrfToken, },

      }).then(response => {

        saveAs(new Blob([response.data],{type: 'application/zip'}), "rotated.zip")
        closeModal();
      })
      .catch( exception => {
        console.log(exception); //TODO display error page
      });
  };
};


// manipulation tool spin
export const runSpin = (minAngle, maxAngle, stepSize, axis, pdbA, closeModal) => {
  return function(dispatch) {
    let bodyFormData = new FormData();
    bodyFormData.append('angle_min', minAngle);
    bodyFormData.append('angle_max', maxAngle);
    bodyFormData.append('step_size', stepSize);
    bodyFormData.append('axis', axis);
    bodyFormData.append('pdba', pdbA);

    const csrfToken = getCookie('csrftoken');

    return axios({
      method: "post",
      url: "spin",
      data: bodyFormData,
      responseType: 'blob',
      headers: { "Content-Type": "multipart/form-data", "X-CSRFToken": csrfToken, },

      }).then(response => {

        saveAs(new Blob([response.data],{type: 'application/zip'}), "spinned.zip")
        closeModal();
      })
      .catch( exception => {
        console.log(exception); //TODO display error page
      });
  };
};


// manipulation tool rotate
export const runPerpendicularShift = (distance, pdbA, pdbB, closeModal) => {
  return function(dispatch) {
    let bodyFormData = new FormData();
    bodyFormData.append('distance', distance);
    bodyFormData.append('pdba', pdbA);
    bodyFormData.append('pdbb', pdbB);
    const csrfToken = getCookie('csrftoken');

    return axios({
      method: "post",
      url: "perpendicular_shift",
      data: bodyFormData,
      responseType: 'blob',
      headers: { "Content-Type": "multipart/form-data", "X-CSRFToken": csrfToken, },

      }).then(response => {

        saveAs(new Blob([response.data],{type: 'application/zip'}), "perpShift.zip")
        closeModal();
      })
      .catch( exception => {
        console.log(exception); //TODO display error page
      });
  };
};


// manipulation tool expand
export const runExpand = (distance, pdbA, closeModal) => {
  return function(dispatch) {
    let bodyFormData = new FormData();
    bodyFormData.append('distance', distance);
    bodyFormData.append('pdba', pdbA);
    const csrfToken = getCookie('csrftoken');

    return axios({
      method: "post",
      url: "expand",
      data: bodyFormData,
      responseType: 'blob',
      headers: { "Content-Type": "multipart/form-data", "X-CSRFToken": csrfToken, },

      }).then(response => {

        saveAs(new Blob([response.data],{type: 'application/zip'}), "expanded.zip")
        closeModal();
      })
      .catch( exception => {
        console.log(exception); //TODO display error page
      });
  };
};


export const runDetach = (distance, pdbA, closeModal) => {
  return function(dispatch) {
    let bodyFormData = new FormData();
    bodyFormData.append('distance', distance);
    bodyFormData.append('pdba', pdbA);
    const csrfToken = getCookie('csrftoken');

    return axios({
      method: "post",
      url: "detach",
      data: bodyFormData,
      responseType: 'blob',
      headers: { "Content-Type": "multipart/form-data", "X-CSRFToken": csrfToken, },

      }).then(response => {

        saveAs(new Blob([response.data],{type: 'application/zip'}), "deatch.zip")
        closeModal();
      })
      .catch( exception => {
        console.log(exception); //TODO display error page
      });
  };
};

//ph dependency of energy

export const runPhDependencyOfEnergy = (title, titraFile, closeModal) => {
  return function(dispatch) {
    let bodyFormData = new FormData();
     bodyFormData.append('title', title);
     bodyFormData.append('titra', titraFile);
    const csrfToken = getCookie('csrftoken');

    return axios({
      method: "post",
      url: "dependency_of_energy",
      data: bodyFormData,
      responseType: 'blob',
      headers: { "Content-Type": "multipart/form-data", "X-CSRFToken": csrfToken, },

      }).then(response => {

        saveAs(new Blob([response.data],{type: 'application/zip'}), "deatch.zip")
        closeModal();
      })
      .catch( exception => {
        console.log(exception); //TODO display error page
      });
  };
};

export const runFlexibility = (mergeFile, closeModal) => {
  return function(dispatch) {
    let bodyFormData = new FormData();
    bodyFormData.append('pdb', mergeFile);
    const csrfToken = getCookie('csrftoken');


    return axios({
      method: "post",
      url: "flexibility",
      data: bodyFormData,
      headers: { "Content-Type": "multipart/form-data", "X-CSRFToken": csrfToken, },

      }).then(response => {
        closeModal(response.data);
      })
      .catch( exception => {
        console.log(exception); //TODO display error page
      });
  };
};



// WEBPACK FOOTER //
// ./src/actions/toolsActions.js